import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router';
import { useSession } from '@/services/providers/use-session.ts';
import { useScrollToTop } from '@/hooks/use-scroll-to-top.tsx';
import { useServiceWorkerNavigation } from '@/hooks/use-service-worker-navigation.ts';
import { wsService } from '@/services/websocket/websocket-service';

const getTimestampInSeconds = () => Math.floor(Date.now() / 1000);

const loader = document.querySelector('.loader-container')!;
const hideLoader = () => loader.classList.add('loader--hide');

const ProtectedRoute = () => {
  const {
    expiresAt,
    isAuthenticated,
    status: userStatus,
    userId,
    role,
    redirectTo,
  } = useSession();
  useScrollToTop();
  useServiceWorkerNavigation();

  useEffect(() => {
    wsService.connect();
    return () => wsService.disconnect();
  }, []);

  if (!expiresAt || expiresAt < getTimestampInSeconds() || !isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (role === 'Unknown') return null;

  if (userStatus === 'Maintenance' || redirectTo === 'MAINTENANCE_PAGE')
    return <Navigate to="/maintenance" />;

  if (userId) {
    hideLoader();
    return <Outlet />;
  }

  return null;
};

export default ProtectedRoute;
